// @ts-nocheck
import AP from './ap';
const _default_1: AP = new AP();
export default _default_1;
